import React, { useEffect, useState } from "react";
import Icon from "./Icon";
import { categoryStyle } from "../utils";

// Product photo with a category-coloured fallback if the image can't load.
const ProductImage = ({ product, iconSize = 48, className = "" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [product.image]);
  const style = categoryStyle(product.category);

  if (!product.image || failed) {
    return (
      <span
        className={`product-image product-image-fallback ${className}`}
        style={{ background: style.tint, color: style.ink }}
        aria-hidden="true"
      >
        <Icon path={style.icon} size={iconSize} strokeWidth={1.4} />
      </span>
    );
  }
  return (
    <span className={`product-image ${className}`}>
      <img src={product.image} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />
    </span>
  );
};

export default ProductImage;
